import React, { useState } from "react";
import { ReactComponent as SwitchOnn } from "assets/img/icons/switchOnn.svg";
import { ReactComponent as SwitchOff } from "assets/img/icons/switchOff.svg";
import CourseService from "services/CourseService";
import { useToasts } from "react-toast-notifications";

const styles = {
  root: {
    cursor: "pointer",
  },
};

export default ({ team, setTeam }) => {
  const { addToast } = useToasts();
  const classes = styles;
  const [enabled, setEnabled] = useState(team?.profile?.enable_course_sharing || false);

  const handleToggleChange = async (value) => {
    try {
      await CourseService.toggleCourseSharing(team.id, value);
      
      setEnabled(value);
      setTeam({
        ...team,
        profile: {
          ...team.profile,
          enable_course_sharing: value
        }
      });
      
      addToast(
        value 
          ? "Course sharing enabled for this team"
          : "Course sharing disabled for this team",
        { appearance: value ? "success" : "error" }
      );
    } catch (error) {
      console.error("Error toggling course sharing:", error);
      addToast("Failed to update course sharing settings", { appearance: "error" });
    }
  };

  return (
    <>
      <div style={classes.root}>
        {!enabled && (
          <SwitchOnn
            className="mx-2 switchIconOff"
            onClick={() => handleToggleChange(!enabled)}
          />
        )}
        {enabled && (
          <SwitchOff
            className="mx-2 switchIcon"
            onClick={() => handleToggleChange(!enabled)}
          />
        )}
        <span>Allow Course Sharing </span>
        <span className="headingSecondaryTextColor">From Other Teams</span>
      </div>
    </>
  );
}; 